import React from "react";
import styles from "./styles.css";
import {STEPS} from "./constants";

const SellEasySteps = () => {

    return (
        <div styleName={"styles.sellAnotherCar"}>
            <h2>Process of selling used car</h2>
            <ul styleName={"styles.sellAnotherCardWrapper"}>
                {
                    STEPS.map(({img, title, subTitle, description}) => (
                        <li key={title}>
                            <picture styleName={"styles.bannerWrapper"}>
                                <img src={img} alt={subTitle} />
                            </picture>
                            <div styleName={"styles.cardDetails"}>
                                <span>{title}</span>
                                <h3>{subTitle}</h3>
                                <p>{description}</p>
                            </div>

                        </li>
                    ))
                }
            </ul>
        </div>
    );
};

export default SellEasySteps;
